module.exports = __webpack_public_path__ + "img/nothing@2x.d3035367.png";